import { useEffect, useState } from "react";
import Lenis from "lenis";
import api from "@/lib/api";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import ProjectsSection from "@/components/site/ProjectsSection";
import About from "@/components/site/About";
import Leadership from "@/components/site/Leadership";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => {});
  }, []);

  const ongoing = projects.filter((p) => p.status === "ongoing");
  const completed = projects.filter((p) => p.status === "completed");

  return (
    <div className="bg-black text-white min-h-screen" data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <ProjectsSection
        id="projects"
        index="01"
        label="Now Rising"
        title="Ongoing Projects"
        projects={ongoing}
        emptyText="New addresses are being drafted. Speak to us about what's next."
      />
      <About />
      <Leadership />
      <ProjectsSection
        id="completed"
        index="04"
        label="Delivered"
        title="Completed Projects"
        projects={completed}
        intro={
          <>
            With <span className="text-[#C5A059]">15+ years of experience</span> in real estate development, Taha Developers has successfully delivered quality residential and commercial projects built on a foundation of trust, craftsmanship, and customer satisfaction. With <span className="text-[#C5A059]">250+ units sold</span> to families, we take pride in creating thoughtfully designed spaces that people are proud to call home. Every completed project reflects our commitment to quality construction, attention to detail, and long-term value for our customers.
          </>
        }
        emptyText="Individual showcases of our delivered landmarks are being curated — explore our ongoing projects above."
        compact
      />
      <Contact projects={projects} />
      <Footer />
    </div>
  );
}
